import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';

import Header from '../map/components/Header';
import PopupDefault from '../map/components/popups/PopupDefault';
import MemberHeader from './parts/MemberHeader';
import MemberFooter from './parts/MemberFooter';
import Dashboard from './Dashboard';
import ContributorDashboard from './ContributorDashboard';

const MemberArea = () => {
  const { first_name } = useSelector(s => s.auth);
  const data = window.pagedata;

  return (
    <>
      <Header/>
      <PopupDefault/>
      {
        first_name && window.auth.role !== 'ROLE_USER' && (
          <>
            {
              window.auth.role === 'ROLE_CONTRIBUTOR'
                ? <ContributorDashboard/>
                : <Dashboard/>
            }
          </>
        )
      }
      {
        first_name && window.auth.role === 'ROLE_USER' && (
          <section id="member-area">
            <MemberHeader title="Member Area"/>
            <div id="breadcrumb">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 col-xs-12">
                    <div className="breadcrumb-items">
                        <ul id="breadcrumbs" className="breadcrumbs">
                          <li>
                            <a
                              className="bread-link bread-home"
                              href="/"
                              title="Home"
                            >
                              Home/Map
                            </a>
                          </li>
                          <li>
                            <strong className="bread-current">
                              Member Area
                            </strong>
                          </li>
                        </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="member-block-style">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <h5 className="member-block-title">
                      <i className="fa fa-list"/> Your downloaded dataset:
                    </h5>
                  </div>
                </div>
              </div>
              <div className="container-fluid">
                <div className="row">
                  <div className="col">
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="thead-dark">
                          <tr>
                            {/* <th scope="col">#</th> */}
                            <th scope="col">Downloaded</th>
                            <th scope="col" style={{ minWidth: 300 }}>
                              Study
                            </th>
                            {/*<th scope="col">Author(s)</th>
                            <th scope="col">Type</th>*/}
                            <th scope="col" style={{ minWidth: 300 }}>
                              Permission
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            data.my_downloads.map((d,i)=>{
                              return (
                                <tr key={i}>
                                  {/* <th scope="row">{i+1}</th> */}
                                  <td>
                                    {
                                      moment.utc(d.downloadDatetime).tz(
                                        moment.tz.guess()
                                      ).fromNow()
                                    }
                                    <br/>
                                    <small>
                                      <b>
                                        {
                                          moment.utc(d.downloadDatetime).tz(
                                            moment.tz.guess()
                                          ).format('D MMM YYYY')
                                        }
                                      </b>
                                      <br />
                                      <i className="fa fa-clock-o" /> {
                                        moment.utc(d.downloadDatetime)
                                          .tz(moment.tz.guess())
                                          .format('hh:mm a')
                                      }
                                    </small>
                                  </td>
                                  <td>
                                    <a href={`/study/${d.studyId}`}>
                                      {d.title}
                                    </a>
                                    <br/>
                                    {
                                      d.reason && 
                                      <span>{d.reason}</span>
                                    }
                                  </td>
                                  {/*<td>Coad L.</td>
                                  <td>{d.type}</td>*/}
                                  <td dangerouslySetInnerHTML={{
                                    __html: d.dcaUserCaption
                                  }} />
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <MemberFooter/>
          </section>
        )
      }
    </>
  )
};

export default MemberArea;
